<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="user" prop="userId">
                <a-input v-model="queryParam.userId" :maxLength="32" :placeholder="$t('请输入')+'user'" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('优惠券名称')" prop="couponName">
                <a-input v-model="queryParam.couponName" :maxLength="32" :placeholder="$t('请输入')+$t('优惠券名称')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('状态')" prop="status">
                <a-select v-model="queryParam.status" placeholder="" allow-clear>
                  <a-select-option :value="1">{{ $t('未使用') }}</a-select-option>
                  <a-select-option :value="2">{{ $t('已使用') }}</a-select-option>
                  <a-select-option :value="3">{{ $t('已过期') }}</a-select-option>
                  <a-select-option :value="4">{{ $t('已作废') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('领取时间开始')" prop="receiveTime">
                <a-date-picker
                  v-model="queryParam.receiveTimeBeginTime"
                  format="YYYY-MM-DD HH:mm:ss"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('领取时间结束')" prop="receiveTime">
                <a-date-picker
                  v-model="queryParam.receiveTimeEndTime"
                  format="YYYY-MM-DD HH:mm:ss"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('过期时间开始')" prop="receiveTime">
                <a-date-picker
                  v-model="queryParam.expireTimeBeginTime"
                  format="YYYY-MM-DD HH:mm:ss"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('过期时间结束')" prop="receiveTime">
                <a-date-picker
                  v-model="queryParam.expireTimeEndTime"
                  format="YYYY-MM-DD HH:mm:ss"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('使用时间开始')" prop="receiveTime">
                <a-date-picker
                  v-model="queryParam.useTimeBeginTime"
                  format="YYYY-MM-DD HH:mm:ss"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('使用时间结束')" prop="receiveTime">
                <a-date-picker
                  v-model="queryParam.useTimeEndTime"
                  format="YYYY-MM-DD HH:mm:ss"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <table-setting
          style="margin-bottom: 24px;"
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: '160%', y: tableScrollY }"
      >
        <span slot="couponType" slot-scope="text, record">
          <a-tag v-if="record.couponType === 1" color="blue">Spend&Save Coupon</a-tag>
          <a-tag v-else-if="record.couponType === 2" color="green">Discount Coupon</a-tag>
          <a-tag v-else-if="record.couponType === 3" color="orange">{{ $t('运费券') }}</a-tag>
        </span>
        <span slot="amount" slot-scope="text, record">
          <span v-if="record.couponType === 1">{{ record.amount }}</span>
          <span v-else-if="record.couponType === 2">{{ 100 - record.discountRate *100 }}% OFF</span>
          <span v-else-if="record.couponType === 3">{{ record.amount }}</span>
        </span>
        <span slot="receiveTime" slot-scope="text, record">
          {{ parseTime(record.receiveTime) }}
        </span>
        <span slot="useTime" slot-scope="text, record">
          {{ parseTime(record.useTime) }}
        </span>
        <span slot="expireTime" slot-scope="text, record">
          {{ parseTime(record.expireTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="updateTime" slot-scope="text, record">
          {{ parseTime(record.updateTime) }}
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag v-if="record.status === 1" color="orange">{{ $t('未使用') }}</a-tag>
          <a-tag v-else-if="record.status === 2" color="green">{{ $t('已使用') }}</a-tag>
          <a-tag v-else-if="record.status === 3" color="red">{{ $t('已过期') }}</a-tag>
          <a-tag v-else-if="record.status === 4" color="gray">{{ $t('已作废') }}</a-tag>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDelete(record)" v-hasPermi="['coupon:couponuser:remove']">
            <a-icon type="delete" />{{ $t('删除优惠券') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCouponUser, listCouponUser, delCouponUser } from '@/api/coupon/couponUser'
import CustomDictTag from '@/components/DictCustomTag'
import { mapGetters } from 'vuex'
import moment from 'moment'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'CouponUser',
  components: {
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: undefined,
        couponId: undefined,
        couponName: undefined,
        userName: undefined,
        userId: undefined,
        grantType: undefined,
        operatorId: undefined,
        receiveTime: undefined,
        expireTime: undefined,
        useTime: undefined,
        status: undefined,
        orderId: undefined,
        isLocked: undefined,
        expireTimeBeginTime: undefined,
        expireTimeEndTime: undefined,
        useTimeBeginTime: undefined,
        useTimeEndTime: undefined,
        receiveTimeBeginTime: undefined,
        receiveTimeEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('优惠券名称'),
          dataIndex: 'couponName',
          ellipsis: true,
          align: 'center',
          fixed: 'left'
        },
        {
          title: this.$t('优惠券类型'),
          dataIndex: 'couponType',
          scopedSlots: { customRender: 'couponType' },
          align: 'center'
        },
        {
          title: this.$t('面额'),
          dataIndex: 'amount',
          scopedSlots: { customRender: 'amount' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('满多少元可用'),
          dataIndex: 'thresholdAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('领取人姓名'),
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('领取人手机号'),
          dataIndex: 'userMobile',
          width: '180px',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('领取时间'),
          dataIndex: 'receiveTime',
          width: '180px',
          scopedSlots: { customRender: 'receiveTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('使用时间'),
          dataIndex: 'useTime',
          width: '180px',
          scopedSlots: { customRender: 'useTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('过期时间'),
          dataIndex: 'expireTime',
          width: '180px',
          scopedSlots: { customRender: 'expireTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('状态'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '180px',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right'
        }
      ]
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    /** 查询用户领券/发放记录列表 */
    getList() {
      this.loading = true
      pageCouponUser(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        id: undefined,
        couponId: undefined,
        userId: undefined,
        grantType: undefined,
        operatorId: undefined,
        receiveTime: undefined,
        status: undefined,
        orderId: undefined,
        isLocked: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk() {
          let data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delCouponUser(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(
                message,
                3
              )
            })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk() {
          that.download('coupon/coupon/user/export',
            that.queryParam
            , `${that.$t('用户领券/发放记录')}_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    }
  }
}
</script>
